module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraBold.2beb9188.woff2";